import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), React.createElement("path", {
    d: "M17.368 1.584l-.952-.952a2.157 2.157 0 0 0-3.054 0L2.954 11.041 0 18l6.959-2.954L17.368 4.638a2.16 2.16 0 0 0 0-3.054zM6.276 14.032l-4.011 1.702 1.702-4.011 8.454-8.454 2.308 2.308-8.453 8.455zM16.519 3.789l-.941.941-2.308-2.308.941-.941a.953.953 0 0 1 .678-.281c.256 0 .497.1.678.281l.952.952a.96.96 0 0 1 0 1.356z"
  }));
};

export default SvgComponent;